import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';
import moment from 'moment';

@Directive({
  selector: '[appTwoDigitsValidator],[appTwoDigitsValidator][ngModel]',
  providers: [
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TwoDigitsValidatorDirective)
    }
  ]
})
export class TwoDigitsValidatorDirective {
  private message: string;

  constructor() { }

  validate(c: AbstractControl): { [key: string]: any } {
    return this.validateData(c.value) ? null : { message: this.message };
  }

  validateData(value) {
    this.message = undefined;

    if (!value || value.length < 6) {
      return true;
    }

    const emissao = moment(value, 'MMYYYY');

    if (value.length !== 6 || !emissao.isValid()) {
      this.message = 'Data inválida';
      return false;
    }

    return true;
  }
}
